/*
 * QUEST SOFTWARE PROPRIETARY INFORMATION
 *
 * This software is confidential.  Quest Software Inc., or one of its
 * subsidiaries, has supplied this software to you under terms of a
 * license agreement, nondisclosure agreement or both.
 *
 * You may not copy, disclose, or use this software except in accordance with
 * those terms.
 *
 *
 * Copyright 2026 Quest Software Inc.
 * ALL RIGHTS RESERVED.
 *
 * QUEST SOFTWARE INC. MAKES NO REPRESENTATIONS OR
 * WARRANTIES ABOUT THE SUITABILITY OF THE SOFTWARE,
 * EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
 * TO THE IMPLIED WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE, OR
 * NON-INFRINGEMENT.  QUEST SOFTWARE SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE
 * AS A RESULT OF USING, MODIFYING OR DISTRIBUTING
 * THIS SOFTWARE OR ITS DERIVATIVES.
 */

import {
  ActionReducer,
  ActionReducerMap,
  createReducer,
  MetaReducer,
  on
} from '@ngrx/store';
import { environment } from '../../environments/environment';
import { routerReducer } from '@ngrx/router-store';
import { appModuleActions } from '../views/users-management/store/action-types';
import { ProductInfo, SubscriptionsInfo, UserInfo } from '@foglight/angular-common';

export interface AppState {
  serverInfo: ProductInfo;
  staacceptance: any;
  userInfo: UserInfo;
  subscriptionInfo: SubscriptionsInfo[];
  productCofig: any;
}

export const initialAppState: AppState = {
  serverInfo: {},
  staacceptance: null,
  userInfo: {},
  subscriptionInfo: [],
  productCofig: {},
};

export const appReducer = createReducer<AppState>(
  initialAppState,

  // Get Server Info
  on(
    appModuleActions.getServerInfo,
    (state, action): AppState => ({
      ...state,
    })
  ),

  // Set Server Info
  on(appModuleActions.setServerInfo, (state, action): AppState => {
    return { ...state, serverInfo: action.serverInfo };
  }),

  on(
    appModuleActions.getSaasAddendumAcceptance,
    (state, action): AppState => ({
      ...state,
    })
  ),

  on(appModuleActions.setSaasAddendumAcceptance, (state, action): AppState => {
    return { ...state, staacceptance: action.saasAccepted };
  }),

  on(appModuleActions.getUserInfo, (state, action): AppState => {
    return { ...state };
  }),

  on(appModuleActions.setUserInfo, (state, action): AppState => {
    return { ...state, userInfo: action.userInfo };
  }),

  on(appModuleActions.getSubscriptionInfo, (state, action): AppState => {
    return { ...state };
  }),

  on(appModuleActions.setSubscriptionInfo, (state, action): AppState => {
    return { ...state, subscriptionInfo: action.subscriptionInfo };
  }),

  on(appModuleActions.setProductConfiguration, (state, action): AppState => {
    return { ...state, productCofig: action.productCofig };
  }),

  on(appModuleActions.resetInitialState, () => ({ ...initialAppState }))
);

export const reducers: ActionReducerMap<any> = {
  router: routerReducer,
  appReducer: appReducer,
  // auditLogs: fromAuditLogs.auditLogReducer
};

export function logger(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => {
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<AppState>[] = !environment.production
  ? [logger]
  : [];
